import {
    GET_USERS_BY_SEARCH_TEXT,
    SET_USERS_BY_SEARCH_TEXT,
    ADD_EMPLOYEE_TO_COST_CENTER,
    SET_IS_EMPLOYEE_ADDED_TO_COST_CENTER,
    GET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST,
    SET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST
} from './UserBySearchTextType'

const getUserFilterBySearchText = (payload: any) => {
    return {
        type: GET_USERS_BY_SEARCH_TEXT,
        payload
    }
}

const setUserFilterBySearchText = (usersBySearchText: any) => {
    return {
        type: SET_USERS_BY_SEARCH_TEXT,
        usersBySearchText
    }
}

const addEmployeeToCostCenter = (payload: any) => {
    return {
        type: ADD_EMPLOYEE_TO_COST_CENTER,
        payload
    }
}

const setIsEmployeeAddedToCostCenter = (flag: any) => {
    return {
        type: SET_IS_EMPLOYEE_ADDED_TO_COST_CENTER,
        flag
    }
}

const getEmployeesWithHomeCostCenterList = (payload: any) => {
    return {
        type:   GET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST,
        payload
    }
}

const setEmployeesWithHomeCostCenterList = (response: any) => {
    return {
        type: SET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST,
        response
    }
}

export {
    getUserFilterBySearchText,
    setUserFilterBySearchText,
    addEmployeeToCostCenter,
    setIsEmployeeAddedToCostCenter,
    getEmployeesWithHomeCostCenterList,
    setEmployeesWithHomeCostCenterList
}